export default {
  polymer: {
    questionnaire: "调查问卷",
    getInvolvedNow: "立即参与"
  },
  components: {
    indefiniteChoiceQuestions: "不定项选择题",
    editorialComments: "编辑评语",
    voiceRecordingFailed: "语音录制失败，请重试",
    release: "发布",
    myScore: "我的得分",
    editReply: "编辑回复",
    ceviceNotSupport: "当前设备不支持停止",
    multipleBlankQuestions: "多空填空题",
    required: "必填项",
    number: "门",
    score: "分",
    notYet: "暂无",
    noParticipation: "未参与",
    youDidnTPass: "您未通过考试，请再接再厉",
    deleteSelectedItemTips: "您确定要删除选中项么",
    notRequired: "非必填项",
    stopIt: "停止",
    classHours: "班级学时",
    numberOfCourses: "课程门数",
    failedToPlay: "播放音频失败，请重试",
    cache: "缓存",
    currentNonWiFi: "当前为非WIFI环境，已停止播放",
    notSupportVoiceUpload : "当前设备不支持上传语音",
    edit: "编辑",
    unpublished: "未发布",
    isOpen: "已开始",
    enterYourAnswer: "请输入您的答案",
    trainingTime: "培训时间",
    adopt: "通过",
    participated: "已参与",
    answerTips: "请输入答案",
    chapter: "章",
    recordingShouldNotExceed_60s: "录音不能超过60s",
    openingTime: "开班时间",
    theFirst: "第",
    endOfRecording: "录制结束",
    unknown: "未知",
    signInStartTime: "签到发起时间",
    see: "查看",
    comeFrom: "来自",
    peopleAreLearning: "人在学",
    testScores: "考试得分",
    registrationDeadline: "报名截止时间",
    completion: "填空题",
    notOpen: "未开始",
    ginsengAnd: "人参与",
    notSupportWechatPlay: "该格式不支持微信播放，请在APP端查看",
    moreThan: "上传图片的文件超过",
    unlimited: "不限",
    placeOfResidence: "常驻地点",
    _2GCellularNetwork: "2G蜂窝网络",
    examinationTime: "考试时间",
    noAskedAQuestion: "您还没提过问题",
    declinedAuthorization: "您拒绝了录音授权",
    startUp: "启动",
    qualificationPaper: "及格证书",
    to: "于",
    notSupportPlay: "当前设备不支持语音播放",
    peopleAreNotInvolved: "人未参与",
    peopleHaveParticipated: "人已参加",
    pleaseSelectAgain: "请重新选择",
    youCanOnlyChoose: "你最多只能选择",
    asOf: "截止至",
    correct: "正确",
    noNetworkConnection: "未连接网络",
    failedToUpload: "上传失败，请重试",
    voicePlayFailed: "语音播放失败，请重试",
    wiredNetwork: "有线网络",
    deviceNotSupportRecording: "当前设备不支持语音录制",
    uploadError: "上传出错",
    photos: "张照片",
    pleaseEnterATitle: "请输入标题",
    releaseLoadMore: "松开加载更多",
    strip: "条",
    details: "详情",
    reply: "回复",
    NotSupportUploadingPictures: "当前设备不支持上传图片",
    talkingTooShort: "说话时间太短",
    pleasePayAttentionToTraffic: "当前为移动网络，请注意流量",
    writeAPrivateLetter: "写私信",
    noEvaluation: "暂无评价",
    wiFiNetwork: "WiFi网络",
    pleaseUseAppToDownload: "不支持此类型的文件下载,请使用APP进行下载",
    latestPhotosUploaded: "最新上传了照片",
    openInBrowserད: "点击右上角，请选择在浏览器打开",
    reExamTimes: "剩余补考次数",
    anotherAnswerTips: "请输入其他答案",
    candidates: "人选",
    _3GCellularNetwork: "3G蜂窝网络",
    startRecording: "开始录音",
    speaker: "主讲人",
    isOver: "已结束",
    topic: "题",
    certificateOfExcellence: "优秀证书",
    workingIn: "任职于",
    personNotSubmitted: "人未提交",
    classes: "班级",
    error: "错误",
    noSignIn: "人未签到",
    duration: "时长",
    downloads: "次下载",
    systemNotice: "公告",
	systemNotices:"通知",
    noIntroduction: "暂无介绍",
    notSignedIn: "未签到",
    _4GCellularNetwork: "4G蜂窝网络",
    on: "已于",
    notice: "消息",
    submittedBy: "人提交",
    hours: "学时",
    pleaseGoToPc: "请到PC端查看统计结果",
    notRegistered: "未报名",
    learned: "已学",
    itIsNotWiFi: "当前为非WIFI状态，是否继续",
    passRate: "通过率",
    isSubmit: "已提交",
    classSize: "班级人数",
    signIn: "签到",
    personSignIn: "人签到",
    pleaseSelect: "请选择",
    comment: "评语",
    yourPassing: "恭喜您顺利通过考试",
    lineWork: "线上班"
  },
  resource: {
    commonResources: "通用资源",
    resources: "资源",
    resourceDetails: "资源详情",
    classResources: "班级资源",
    goToAppOrPcToDownload: "请前往pc端下载使用",
    downloadDetails: "下载详情"
  },
  student: {
    preschool: "学前",
    learning: "学中",
    onlineEvaluation: "在线测评"
  },
  classes: {
    data: '资料',
    cancelTheLeaveTips: "您确定要取消请假吗",
    teachingEvaluation: "教学评价",
    pleaseEnterTheAnswer: "请输入回答",
    opinionBeEmpty: "意见内容不能为空",
    registered: "已报名",
    classmate: "同学",
    deletePhotoTips: "您确定要删除此相片么",
    notInTheClass: "当前用户不在该班级",
    disagreeAndGiveOpinions: "不同意并给出意见",
    sickLeave: "病假",
    checkInPeriod: "签到时段",
    problemContentEmpTips: "问题内容不能为空",
    enclosure: "附件",
    enflash: "视频",
    pleaseSelectLeaveType: "请选择请假类型",
    classCourses: "班级课程",
    evaluated: "已评价",
    enteringTheClass: "查看项目详情",
    groupLeader: "组长",
    classAnnouncement: "班级公告",
    normalAttendance: "正常出勤",
    urging: "催办",
    curriculumEvaluation: "课程评价",
    discussionContentTips: "请输入讨论内容",
    completed: "已完成",
    agree: "同意",
    signUpNow: "立即报名",
    leaveEarly: "早退",
    loading: "加载中",
    noClassToday: "今天没课放松一下",
    unknownError: "未知错误",
    theInvestigationTerminated: "该调查已终止",
    youDidNotParticipateIn: "您未参加评估",
    noPersonnel: "暂无人员",
    selectUploadPhoto: "请选择需要上传的照片",
    endSignIn: "结束签到",
    evaluationEmptyTips: "评价内容不能为空",
    notSigned: "未签",
    failedToUrge: "催办失败",
    classScheduleCard: "线下课程",
    putQuestions: "提问",
    submitting: "正在提交",
    allStates: "全部状态",
    everyoneSignedIn: "所有人均已签到",
    giveAFalseOpinion: "给假意见",
    talking: "说话中。。。",
    matter: "事",
    signInStartTime: "签到发起时间",
    classDetails: "班级详情",
    enterYourComment: "请输入您的评语",
    search: "搜索",
    noNotes: "暂无笔记",
    announcementDetails: "公告详情",
    leaveReview: "请假审核",
    letSGoPlayForAWhile: "先去玩耍一会吧",
    allSubmitted: "所有均已提交作业",
    topping: "置顶",
    youHaveOrNotStarted: "您已签到,或签到未开始",
    communicationEmpty: "交流内容不能为空",
    noClassInTheEvening: "晚上没课放松一下",
    illness: "病",
    gettingTimedOut: "获取信息超时",
    dataDownload: "资料下载",
    auditFailed: "审核未通过",
    classLocation: "班级地点",
    photo: "相片",
    checkInNotStarted: "签到未开始",
    theInvestigationLaunched: "该调查已启动",
    holdToTalk: "按住说话",
    selectStartTimeOfLeave: "请选择请假开始时间",
    opinion: "意见",
    call: "呼叫",
    notEvaluated: "未评价",
    newReply: "条新回复",
    classLecturer: "班级讲师",
    teacherAnswersQuestions: "教师答疑",
    classPhotoAlbum: "班级相册",
    pleaseWait: "请稍后",
    notGetLocation: "暂时获取不到位置信息",
    ask: "问",
    openEnrollment: "开放报名",
    searchHistory: "搜索历史",
    uploadPhotos: "上传相片",
    operationDetails: "作业详情",
    discuss: "讨论",
    noContent: "暂无内容",
    dropDownToRefresh: "下拉可刷新学员签到情况",
    registrationStatus: "报名状态",
    communicationDetails: "通讯详情",
    noBriefIntroduction: "暂无简介",
    uploadMax9: "一次最多上传9张照片",
    noClassThisMorning: "今天上午没课放松一下",
    empty: "清空",
    pleaseUseAppOrPc: "请到app或pc端使用此功能",
    successfulUrging: "催办成功",
    late: "迟到",
    downloading: "下载中",
    leave: "请假",
    auditPassed: "审核已通过",
    uploading: "上传中...",
    reply: "回复",
    signOutPeriod: "签退时段",
    communication: "交流",
    temporarySignIn: "临时签到",
    suspend: "暂停",
    publishSuccessfully: "发布成功",
    iGotIt: "我知道了",
    reasonsForRejection: "驳回原因",
    pleaseEnterTheQuestion: "请输入问题",
    discussionContentEmpTips: "讨论内容不能为空",
    mailList: "通讯录",
    finished: "已结束",
    classStatus: "班级状态",
    noClassThisAfternoon: "今天下午没课放松一下",
    registrationIsFull: "报名已满",
    underReview: "审核中",
    toBeAnswered: "待回复",
    attendanceDetails: "考勤详情",
    lateLeaveEarly: "迟到/早退",
    personSubmitted: "人已提交",
    selectEndTimeOfLeave: "请选择请假结束时间",
    sendSms: "发送短信",
    compassionateLeave: "事假",
    task: "作业",
    endOfRegistration: "报名结束",
    inTheDevelopment: "开发中，敬请期待...",
    uploadSuccessful: "上传成功",
    uploadFailed: "上传失败",
    applicationDate: "申请日期",
    questionnaire: "问卷",
    personNotSubmitted: "人未提交",
    submit: "提交",
    waiting: "等待中",
    classWork: "班级作业",
    rejected: "已驳回",
    replied: "已回复",
    classSurvey: "班级调查",
    absence: "人缺勤",
    inputTheReasonForLeave: "请输入请假原因",
    certificate: "证书",
    classCommunication: '班级通讯',
    finishTips: "您确定要结束么",
    addedSuccessfully: "新增成功",
    noSignIn: "暂无签到",
    inputLeaveOpinion: "请输入给假意见",
    teacher: "教师",
    toBeReviewed: "待审核",
    examination: "考试",
    classIntroduction: "班级简介",
    messageArea: "留言区",
    studentsNotSignedIn: "未签到学员",
    class: "班级",
    locationServiceDenied: "位置服务被拒绝",
    voiceCannotBeEmpty: "语音不能为空",
    downloadNow: "立即下载",
    uploadLeaveTips: "您还有图片未上传，离开后未上传的图片将不会被上传，是否继续离开",
    classAssessment: "项目评估",
    headmaster: "班主任",
    youHave: "您有",
    allParticipantsSubmitted: "学员已全部提交",
    abnormalData: "数据异常",
    newLeave: "新增请假",
    AssessmentIsNotOver: "评估暂未结束",
    aboutToSignUp: "即将报名",
    notSupportUploading: "当前设备不支持上传图片",
    youHaveThisSurvey: "你已参与过本次调查",
    leaveDate: "请假日期",
    writeComments: "写评语",
    noProblemAtTheMoment: "暂无问题",
    attendance: "考勤情况",
    initiateDiscussion: "发起讨论",
	noResour:"暂无资料",
	addNotes:"添加笔记"
  },
  bag: {
    faceToFaceClass: "面授班",
    notStarted: "未开始",
    finished: "已结束",
    electiveCourse: "选修课",
    failed: "未通过",
    passingState: "通过状态",
    examinationStatus: "考试状态",
    onlineSpecialClass: "网上专题班",
    requiredCourse: "必修课",
    noExamination: "未考试",
    marking: "待补考",
    myStudy: "我的学习",
    iAmLearning: "学习中",
    examineeStatus: "考生状态",
    cancelled: "已取消",
    haveInHand: "进行中",
    passed: "已通过",
    faceToFaceTrainingCourse: "面授培训班",
    noticeNotice: "通知公告",
    onlineClass: "在线班"
  },
  login: {
    loginNetworkErr: "登录异常，请重试",
    passwordEmp: "密码不能为空",
    inputUserName: "请输入用户名",
    loginErr2: "登录异常，请重试",
    loginErr1: "登录异常，即将返回请重试！",
    toHome: "前往首页",
    bind: "绑定",
    bindSuccessOk: "账号绑定成功",
    inputPasword: "请输入密码",
    userNameEmp: "用户名不能为空",
    resetPwdSuccess: "密码重置成功",
    loginPage: "登录页",
	inputCode:"请输入验证码",
    codeErr: "验证码错误",
    sendSuccess: "发送成功",
    bindOtherTips: "您已绑定了其他微信账号，如果更换微信请先解绑微信账号",
    bindExistingAccount: "请绑定已有账号",
    userErr: "账号或密码错误",
    loginConflictTips: "该账号已在其他设备登录！",
    reSend: "重新发送",
    bindSuccessTips: "您已绑定账号成功，可以使用微信登录",
    learningFlowSuccess: "学习流水提交成功",
    messageErr: "短信验证码输入不正确",
    alreadyBind: "您已绑定了微信账号",
    verificationCont: "验证码",
    bindResult: "绑定结果页",
    resetPwdFail: "密码重置失败",
    bindSuccess: "绑定成功",
    loginText: "登录",
    messageEmp: "短信验证码不能为空",
    codeEmp: "验证码不能为空",
    register: "注册"
  },
  evaluateStart: {
    newAnswerArea: "新增答题区域",
    itSTheLastQuestion: "已经是最后一题了",
    shortAnswerQuestions: "简答题",
    classAssessment: "班级评估",
    multipleChoiceQuestions: "多选题",
    listOfTopics: "题目列表",
    handInThePaperTips: "您确定交卷么",
    evaluationQuestions: "评价题",
    tableTitle: "表格题"
  },
  setting: {
    aboutUs: "关于我们",
    resetPassword: "重置密码",
    phoneEmp: "手机号不能为空",
    passwordNotUniform: "新密码不统一",
    bindPhone: "绑定手机号",
    inputFeedback: "请输入意见反馈",
    allowNonWiFiDownload: "允许非WIFI网络下载",
    resendSms: "重新发送短信验证码",
    feedback: "意见反馈",
    helpCenter: "帮助中心",
    originalPassword: "原密码",
    skinSwitch: "皮肤切换",
    bindingSucceeded: "手机绑定成功",
    mobileAlreadyExists: "手机号已存在",
    agreementService: "《善学服务使用协议》",
    warning: "版本所有违者必究",
    confirmPassword: "确认密码",
    setUp: "设置",
    mobileNetworkDownload: "移动网络下载可能会导致超额流量，确认开启？",
    sendSmsCodeTo: "我们会发送短信验证码到",
    passwordleng: "密码由8-16个字符组成",
    email: "Email",
    boundByAnotherAccount: "该手机号已被其他账号绑定",
    inputCode: "请输入验证码",
    mobileNetworkPlay: "移动网络播放可能会导致超额流量，确认开启？",
    allowNonWiFiPlay: "允许非WIFI网络播放",
    serviceTelephone: "客服电话",
    newPassword: "新密码",
    newPasswordemp: "新密码不能为空",
    pleaseInput_11PhoneNumber: "请输入11位大陆手机号",
    downloaded: "已下载",
    phoneFormatError: "手机号格式错误",
    sendSms: "发送短信验证码",
    serviceAgreement: "服务条款使用协议",
    originalPasswordEmp: "原密码不能为空",
    smsVerification: "短信验证",
    codeError: "短信验证码错误",
    nextStep: "下一步",
    passwordResetFailed: "重置密码失败",
    passwordResetSucceeded: "重置密码成功",
    originalPasswordError: "原密码错误",
    logOut: "退出登录"
  },
  exam: {
    examinationResults: "考试结果",
    reExamination: "重新考试",
    inMarking: "阅卷中...",
    passedTheExam: "您考试已通过",
    examinationRecord: "考试记录",
    highScoreRanking: "高分排行榜",
    highestScore: "最高得分",
    historicalRecords: "历史记录",
    examinationIsOver: "考试已结束",
    knowledgeContest: "知识竞赛",
    examinationDuration: "考试时长",
    signUpForTheExam: "报名考试",
    latestScore: "最新得分",
    notAllowedSeeResolution: "此次考试不允许查看解析",
    analysisOfQuestions: "试题解析",
    reExaminationTimes: "剩余补考次数",
    noPassedAllowedSeeResolution: "您考试未通过，不允许查看解析",
    examIsMax: "已达到考试次数上限",
    noAnalysis: "暂无解析",
    startTheExam: "开始考试",
    pleaseSelectOrEnterTheAnswer: "请选择或者输入答案",
    handInPaperTime: "交卷时间已到，系统已为您自动交卷",
    SpecificTimeNotice: "具体时间请等待系统通知"
  },
  teacher: {
    otherMatters: "其它事项",
    newTeachers: "新增教师",
    workUnit: "任职单位",
    teachingExpertise: "授课专长",
    positionTitle: "职务/职称",
    recommendTeachers: "推荐教师",
    teacherName: "教师名称",
    placeOfResidence: "常驻地点",
    notSubmitted: "未提交",
    newlyAdded: "新增",
    instructorDetails: "讲师详情",
    teachingLevel: "适合授课对象层级",
    aboutInstructor: "讲师介绍",
    chargingStandard: "收费标准",
    suitableBusinessLine: "适合业务条线",
    modify: "修改",
    contactInformation: "联系方式",
    teacherProfile: "教师简介",
    pleaseConfirmComplete: "请确认填写完整",
    lectureStyle: "讲课风格",
    thisItemIsRequired: "此项必填",
    allTeachers: "全部教师",
    recommendedUnit: "推荐单位",
    lecturerSResume: "讲师履历"
  },
  common: {
    more: '更多',
    operationFailed: "操作失败",
    pleaseScan: "请扫描正确二维码",
    cancel: "取消",
    noMoreData: "没有更多数据了",
    signInSuccessfully: "签到成功",
    HistoryFlowSednError: "历史流水提交失败!",
    whole: "全部",
    homePage: "首页",
    deletionSucceeded: "删除成功",
    singleAnswer: "单选题",
    modificationFailedPleaseTryAgain: "修改失败，请重试",
    multipleAnswer: "多选题",
    evaluated: "已评价",
    tryRefreshingAndTryAgain: "可尝试刷新后再试",
    examPaperType: "试卷题型",
    saveFailed: "保存失败",
    choiceAnswer: "选择填空题",
    deselectAll: "取消全选",
    sendOut: "发送",
    theSignInHasEnded: "该签到已结束",
    edit: "编辑",
    nothing: "无",
    night: "晚上",
    loading: "加载中...",
    gettingLocation: "正在获取地理位置......",
    submitSuccess: "提交成功",
    doNotOperateFrequently: "请勿频繁操作",
    morning: "上午",
    selectAll: "全选",
    evaluate: "评价",
    chapter: "章节",
    trueAnswer: "判断题",
    other: "其他",
    reasonsForFailure: "失败原因",
    toEvaluate: "去评价",
    submitFailed: "提交失败",
    scan: "扫一扫",
    addedSuccessfully: "添加成功",
    video: "视频",
    courseDownload: "课程下载",
    delete: "删除",
    HistoryFlowSendSuccess: "历史流水提交成功!",
    inputContent: "请输入内容",
    pullUpToLoadMore: "下拉加载更多",
    deletionFailed: "删除失败",
    signOutFailed: "签退失败",
    preservation: "保存",
    file: "文档",
    common: "共",
    deletionFailedPleaseTryAgain: "删除失败，请重试",
    checkInFailed: "签到失败",
    shortAnswer: "简答题",
    noNet: "好像没网了",
    checkAll: "查看全部",
    determine: "确定",
    pleaseGiveAScore: "请打分",
    i: "我",
    collectionSuccessful: "收藏成功",
    multiplePictures: "多图片",
    putUp: "收起",
    examNumber: "考试次数",
    people: "人",
    signOutSucceeded: "签退成功",
    picture: "图片",
    noDataText: "暂无数据",
    minute: "分钟",
    addFailed: "添加失败",
    afternoon: "下午",
    newReply: "新回复",
    hotSearch: "热门搜索",
    submittedSuccessfully: "提交成功",
    signedIn: "已签到",
    savedSuccessfully: "保存成功",
    HistoryFlowSend: "历史流水提交",
    searchHistory: "搜索历史",
    savePicture: "保存图片",
    examTime: "考试时长",
    loading2: "载入中",
    open: "展开",
    modificationSucceeded: "修改成功"
  },
  msExamplan: {
    wrongTopic: "错题",
    practice: "练习",
    successfulRegistration: "报名成功",
    clickToSubmitPaper: "点击交卷按钮可提交试卷",
    accuracy: "正确率",
    collected: "已收藏",
    entranceExamination: "门考试",
    numberOfErrors: "错误次数",
    totalQuestionBank: "题库总量",
    mockTest: "模拟考试",
    registrationExamination: "考试报名",
    submitAnswers: "提交答案",
    registrationClosed: "考试报名已截止",
    rankingList: "排行榜",
    startPracticing: "开始练习",
    theExamCancelled: "本次考试已取消",
    fullScore: "满分",
    theExamOver: "本次考试已结束",
    totalTopic: "题目总量",
    wrongQuestionBank: "错题库",
    cantToRegister: "审核未通过无法继续报名",
    viewResolution: "查看解析",
    examPaperCannotOpene: "阅卷中不能打开试卷",
    slidingNextQuestion: "左右滑动也可以切换至上一题和下一题",
    yourScore: "您的得分",
    keepPracticing: "继续练习",
    removeWrongQuestions: "移除错题",
    setOfExercises: "套练习",
    collection: "收藏",
    practiceBeforeExam: "考前练习",
    questionBankExercises: "题库练习",
    allHave: "共有",
    removed: "已移除",
    numberOfReExam: "可补考次数",
    cancelRegistration: "撤回报名",
    questionBank: "题库",
    wrongQuestionSet: "错题集",
    practiced: "已练习"
  },
  chat: {
    privateMessageTips: "请输入私信内容",
    privateMsgEmptyTips: "私信内容不能为空",
    privateMsgDeletedSuccessfully: "私信删除成功",
    privateMsgDeleteTips: "您确定要删除此私信么",
    privateLetter: "私信",
    nowYouCanStartChatting: "现在可以开始聊天了"
  },
  course: {
    lastTime: "上次耗时",
    courseIntroduction: "课程简介",
    rightAnswer: "正确答案",
    courseType: "课程分类",
    PracticeInClass: "随课练习",
    answerOk: "回答正确",
    examNotice: "考试须知",
    data: "资料",
    examInfo: "考试详情",
    aubutCourse: "相关课程",
    last5MinNotice: "距离交卷时间结束还剩5分钟，时间用尽后系统会自动交卷，请抓紧时间答卷",
    bag: "书包",
    ExamInClass: "随课考",
    thematicEvaluation: "专题评价",
    elective: "选修",
    chapterDownloaded: "章节已下载",
    me: "我",
    changeIt: "换一换",
    courseInfo: "课程详情",
    evaluated: "您已评价过该课程",
    newest: "最新",
    questionList: "题目列表",
    takeNotes: "记笔记",
    info: "详情",
    pausePlay: "暂停播放",
    startPlay: "开始播放",
    inputNoteContent: "请输入笔记内容",
    onlineCourses: "在线课程",
    nowCmpletion: "当前完成",
    exam: "考试",
    enableLogFunction: "开启日志功能",
    handInPapers: "交卷",
    courseDetails: "课程详情",
    answerErr: "回答错误",
    myNotice: "我的笔记",
    referenceAnswer: "参考答案",
    courseLecturer: "课程讲师",
    editFail: "编辑失败",
    note: "笔记",
    questionTips2: "注：绿色为正确题目，红色为错误题目，点击题号进入题目",
    private: "私有",
    notEnoughTimeTips: "没有达到要求的学习时长,无法评价",
    isRecordedHour: "是否记录学时",
    questionTips1: "注：绿色为已答题目，点击题号进入题目",
    handInPapersNotice: "交卷提醒",
    courseDownload: "课程下载",
    recommendedCourses: "推荐课程",
    keepLearning: "继续学习",
    yourAnswer: "您的答案",
    playOver: "播放结束",
    openClass: "公开课",
    manLearning: "人学习",
    allCourses: "全部课程",
    specialTraining: "专题培训",
    hottest: "最热",
    chapterSwitching: "章节切换",
    publick: "公开",
    CourseType: "课程类型",
    autoPlayNextVideo: "自动播放下一视频",
    selectCategory: "选择分类",
    noResourcesPlaying: "无可继续播放的资源",
    handInPapersConfirm: "您确定交卷么",
    joinInLearning: "加入学习",
    exerciseResults: "练习结果",
    surplus: "剩余",
    practiceAgain: "重新练习",
    deleteConfirm: "您确定要删除么",
    handInPapersErrorNotice: "交卷失败，将跳转至结果页",
    totalSpace: "总空间",
    editSuccess: "编辑成功",
    examNumber: "考试次数",
    mobileNotSupported: "该资源不支持移动播放，请前往pc查看",
    compulsory: "必修",
    closeNotice: "交卷后，才可关闭当前页",
    specialTrainingCourses: "专题培训课程",
    noNotice: "暂无须知",
    comprehensiveScore: "综合得分",
    HistoryFlowSend: "历史流水提交",
    selectDownloadChapter: "请先选择下载章节!",
	jiangYi:"讲义"
  },
  survey: {
    afterSchool: "学后",
    questionnaireDetails: "问卷详情"
  },
  information: {
    leaveAMessage: "写留言",
    inputTheMessageContent: "请输入留言内容",
    leavingAMessage: "留言"
  },
  user: {
    userName: '用户名',
    systemNotification: '系统通知',
    teacherRecommendation: '教师推荐',
    learningArchives: '学习档案',
    onlineLearning: '党校网络教学平台',
    faceToFaceLearning: '面授学习',
    currentClass: "当前班级",
    unbound: "未绑定",
    administration: "管理",
    youAreIn: "您在",
    learningReminders: "条学习提醒",
    binding: "正在绑定",
    onlineClassHours: "在线学时",
    exceeds_10mPleaseReSelect: "上传头像的文件超过10M,请重新选择!",
    optionStatistics: "选项统计",
    myMessage: "我的消息",
    exceeds_2mPleaseReSelect: "上传头像的文件超过2M,请重新选择!",
    accountSecurity: "账号安全",
    assessment: "评估",
    unbindWechat: "解绑微信",
    post: "职务",
    exercises: "练习题",
    inputickname: "请输入昵称",
    nickname: "昵称",
    loginName: "登录名",
    displayName: '显示名',
    myQuestionnaire: "我的问卷",
    rank: "职级",
    questionnaireResults: "问卷结果",
    female: "女",
    cancelPhotoTaking: "取消拍照",
    cancelAuthorization: "取消授权",
    cancelCollection: "取消收藏",
    editingMaterials: "编辑资料",
    noGrouping: "暂无分组",
    myCollection: "我的收藏",
    onlineCourses: "线上课程",
    failedAuthentication: "获取登录认证失败",
    pleaseEnter: "请输入",
    phoneNumber: "手机号码",
    myLeave: "我的请假",
    reset: "重置",
    historyClass: "历史班级",
    pleaseWaitNotice: "具体时间请等待系统通知",
    male: "男",
    private: "私密",
    gender: "性别",
    selectPhotos: "选择照片",
    selectFromPhone: "从手机相册选择",
    bindingFailed: "绑定失败",
    myClass: "我的班级",
    idNumber: "身份证号",
    cycle: "周期",
    conversations: "个对话",
    areYouSure: "您确认要解除绑定",
    theInputIsEmpty: "输入内容为空",
    unbinding: "正在解除绑定",
    myDownloads: "我的下载",
    assessmentDetails: "考核明细",
    email: "邮箱",
    classSurveyResults: "班级调查结果",
    assessmentResults: "评估结果",
    evaluationResults: "评价结果",
    pleaseSelectACourse: "请选择课程或者资源再进行删除",
    bound: "已绑定",
    fullName: "姓名",
    totalSpace: "总空间",
    curriculum: "课程",
    onPcOrApp: "请到pc端或app换头像",
    photograph: "拍照",
    cellPhoneNumber: "手机号",
    myNotes: "我的笔记",
    faceToFaceHours: "面授学时",
    to: "至",
    complete: "完成",
    editPersonalInformation: "编辑个人信息",
    downloadCompleted: "已完成下载"
  }
}
